export const getBaseApi = () => {
  return process.env.REACT_APP_BASE_URL
    ? process.env.REACT_APP_BASE_URL + "api/"
    : "https://rankify-be.onrender.com/api/";
};
